/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateOpportunityWarmingQuestionExperienceSchema } from './candidate-opportunity-warming-question-experience-schema';
import { candidateReputationClarificationSchema } from './candidate-reputation-clarification-schema';
import { candidateSchema } from './candidate-schema';
import { clientRequestSchema } from './client-request-schema';
import { opportunitySchema } from './opportunity-schema';
import { positionSchema } from './position-schema';
import { userSchema } from './user-schema';
import { AlertDateTrigger, CandidateStatus, DisplayBillingRate, DsMatchSummaryStatus, RejectionLossCode, RollOffReasonCode, WarmingQuestionFieldMap, WarmingQuestionType, WeeklyTimeUnit } from "../enums";
export const candidateOpportunitySchema: z.AnyZodObject = z.object({
  annualSalary: z.number().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateAvailabilityNotes: z.string().nullish(),
  candidateBaseAnnualSalary: z.number().nullish(),
  candidateBonusPercentage: z.number().nullish(),
  candidateExperienceNotes: z.string().nullish(),
  candidateExploringOutsideRoles: z.string().nullish(),
  candidateId: z.string().uuid().nullish(),
  candidateInterestedAt: z.string().datetime().nullish(),
  candidateInterviewingAt: z.string().datetime().nullish(),
  candidateIsInterested: z.boolean().nullish(),
  candidatePlannedTimeOffNotes: z.string().nullish(),
  candidateReasonForNo: z.string().nullish(),
  candidateReputationClarification: 
    z.lazy(() => candidateReputationClarificationSchema)
  .nullish(),
  candidateStatus: z.nativeEnum(CandidateStatus).nullish(),
  candidateStatusMessage: z.string().nullish(),
  candidateStatusMessageDismissedAt: z.string().datetime().nullish(),
  candidateStatusUpdatedAt: z.string().datetime().nullish(),
  candidateSubmittedAt: z.string().datetime().nullish(),
  candidateWorkscheduleAnnualHours: z.number().nullish(),
  clientRequest: z.lazy(() => clientRequestSchema).nullish(),
  compensationType: z.string().nullish(),
  consultant1099UtilizationWarning: z.boolean().nullish(),
  created: z.lazy(() => userSchema).nullish(),
  createdAt: z.string().datetime().nullish(),
  createdBy: z.string().uuid().nullish(),
  displayBillingRate: z.nativeEnum(DisplayBillingRate).nullish(),
  dsMatchSummary: 
    z.object({
      data: 
        z.object({
          clientSubmissionDraft: z.string().nullish(),
          concerns: z.array(z.string()).nullish(),
          evidence: z.array(z.string()).nullish(),
          fitDecision: z.string().nullish(),
          topMatchPoints: z.array(z.string()).nullish(),
        })
      .nullish(),
      error: 
        z.object({
          message: z.string().nullish(),
          statusCode: z.number().int().nullish(),
        })
      .nullish(),
      failedAt: z.string().datetime().nullish(),
      receivedAt: z.string().datetime().nullish(),
      requestedAt: z.string().datetime().nullish(),
      status: z.nativeEnum(DsMatchSummaryStatus).nullish(),
    })
  .nullish(),
  ebillingMandateMultiple: z.number().nullish(),
  exchangeRate: z.number().nullish(),
  hasBeenWarmed: z.boolean().nullish(),
  hasNoConflictOfInterest: z.boolean().nullish(),
  hourlyRate: z.number().nullish(),
  hourlyRateBurdened: z.number().nullish(),
  hourlySalary: z.number().nullish(),
  id: z.string().uuid(),
  isActiveForSubmission: z.boolean().nullish(),
  isPriorityTalentAtSelected: z.boolean().nullish(),
  lastUpdatedBy: z.string().uuid().nullish(),
  lastUpdatedByUser: z.lazy(() => userSchema).nullish(),
  marginApprovalCeiling: z.number().nullish(),
  marginApprovalFloor: z.number().nullish(),
  marginFloorPct: z.number().nullish(),
  marginTargetPct: z.number().nullish(),
  marginUpperPct: z.number().nullish(),
  meetsMinPayRequirements: z.boolean().nullish(),
  onboardingDetails: 
    z.object({
      additionalContacts: 
        z.array(
          z.object({
            email: z.string().nullish(),
            jobTitle: z.string().nullish(),
            name: z.string().nullish(),
            phoneNumber: z.string().nullish(),
          })
        )
      .nullish(),
      contact: 
        z.object({
          email: z.string().nullish(),
          jobTitle: z.string().nullish(),
          name: z.string().nullish(),
          phoneNumber: z.string().nullish(),
        })
      .nullish(),
      displayTimeUnit: z.nativeEnum(WeeklyTimeUnit).nullish(),
      displayTimeUnitUpdatedAt: z.string().datetime().nullish(),
      notes: z.string().nullish(),
      updatedAt: z.string().datetime().nullish(),
    })
  .nullish(),
  onboardingEmailSentAt: z.string().datetime().nullish(),
  openToLowerEsc: z.boolean().nullish(),
  openToLowerEscCompensationAmount: z.number().nullish(),
  openToLowerEscCompensationPercentage: z.number().int().nullish(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  pinnedByClient: z.boolean(),
  position: z.lazy(() => positionSchema).nullish(),
  positionId: z.string().uuid().nullish(),
  previousCandidateStatus: z.string().nullish(),
  previousPositiveCandidateStatus: z.string().nullish(),
  productBurdenRateMultiple: z.number().nullish(),
  productPremiumRateMultiple: z.number().nullish(),
  proposedCostTarget: z.number().nullish(),
  proposedHourlyCompCandidateCurrency: z.number().nullish(),
  proposedHourlyCompensation: z.number().nullish(),
  proposedHourlyRate: z.number().nullish(),
  proposedMarginTarget: z.number().nullish(),
  rejectionLossCode: z.nativeEnum(RejectionLossCode).nullish(),
  rejectionLossCodeCustomMessage: z.string().nullish(),
  rollOffReason: z.nativeEnum(RollOffReasonCode).nullish(),
  salesforceQuoteLineId: z.string().nullish(),
  showCandidateReputation: z.boolean(),
  submissionDescription: z.string().nullish(),
  submissionRank: z.number().int().nullish(),
  updatedAt: z.string().datetime().nullish(),
  viewedOnHistoryAt: z.string().datetime().nullish(),
  warmingQuestionExperiences: 
    z.array(z.lazy(() => candidateOpportunityWarmingQuestionExperienceSchema))
  .nullish(),
  warmingQuestions: 
    z.object({
      experiences: 
        z.object({
          question: z.string().nullish(),
        })
      .nullish(),
      questions: 
        z.array(
          z.object({
            alertDate: z.string().nullish(),
            alertDateTrigger: z.nativeEnum(AlertDateTrigger).nullish(),
            alertText: z.string().nullish(),
            answer: z.string().nullish(),
            fieldMap: z.nativeEnum(WarmingQuestionFieldMap).nullish(),
            id: z.string().uuid().nullish(),
            question: z.string().nullish(),
            questionDescription: z.string().nullish(),
            questionOptions: 
              z.array(
                z.object({
                  alertOn: z.boolean().nullish(),
                  id: z.string().uuid().nullish(),
                  selectionText: z.string().nullish(),
                  userSelected: z.boolean(),
                })
              )
            .nullish(),
            required: z.boolean(),
            type: z.nativeEnum(WarmingQuestionType).nullish(),
          })
        )
      .nullish(),
    })
  .nullish(),
});

export type CandidateOpportunity = z.infer<typeof candidateOpportunitySchema>;
